'use client';

import { useState } from 'react';
import { ExpandMoreIcon } from '../icons';
import styles from './Blog.module.css';

interface FAQItem {
  question: string;
  answer: string;
}

interface BlogFAQSectionProps {
  faq: FAQItem[];
}

export function BlogFAQSection({ faq }: BlogFAQSectionProps) {
  const [expanded, setExpanded] = useState<number | false>(false);

  return (
    <div className={styles.faqSection}>
      <h2 className={styles.faqTitle}>
        Frequently Asked Questions
      </h2>
      {faq.map((item, index) => (
        <div key={index} className={styles.faqItem}>
          <div
            className={styles.faqItemHeader}
            onClick={() => setExpanded(expanded === index ? false : index)}
          >
            <p className={styles.faqItemQuestion}>{item.question}</p>
            <span className={`${styles.faqItemIcon} ${expanded === index ? styles.faqItemIconExpanded : ''}`}>
              <ExpandMoreIcon />
            </span>
          </div>
          {expanded === index && (
            <p className={styles.faqItemAnswer}>{item.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
}
